import { useInfiniteQuery } from 'react-query';
import { getSceneSubscriptions } from '../../services/sceneService';

const PER_PAGE = 5;

export function useGetSceneSubscriptions() {
  return useInfiniteQuery(
    ['sceneSubscriptions'],
    ({ pageParam = 1 }) => getSceneSubscriptions({ page: pageParam, perPage: PER_PAGE }),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      getNextPageParam: (lastPage) => {
        if (lastPage?.meta?.pagination?.currentPage < lastPage?.meta?.pagination?.totalPages) {
          return lastPage?.meta?.pagination?.currentPage + 1;
        }
        return undefined;
      }
    }
  );
}